enum RecordTypes {
  Apprenticeship = 'Apprenticeship',
  Employer = 'Employer',
  SocialPrograms = 'SocialPrograms',
  IndividualFunding = 'IndividualFunding',
  SelfPaid = 'SelfPaid',
  VAE = 'VAE',
  Generic = 'Generic',
}

export default RecordTypes;
